import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { articlesKeys } from './articlesKeys'
import { useDispatch } from 'react-redux'
import { ArticleFlat } from 'types'
import { ArticleService } from 'api/services/ArticleService'
import { articleMetaUpsert } from 'redux/actions'

export const useArticle = (
  key: string,
  reactQueryOptions: UseQueryOptions<{ article: ArticleFlat }> = {},
  withArticleView?: boolean,
) => {
  const dispatch = useDispatch()
  return useQuery<{ article: ArticleFlat }>(
    articlesKeys.detail(key),
    async () => {
      const res = await ArticleService.getArticle(key, { withArticleView: !!withArticleView })
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      dispatch(articleMetaUpsert(res.data.article))
      return res.data
    },
    {
      retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
      refetchOnWindowFocus: false,
      ...reactQueryOptions,
    },
  )
}
